import { _ROLES_BACK } from "../../utils/constants";
import { BaseBudgetInput } from "../../components/budget/BaseBudgetInput";
import { Table } from "../../components/indicators/template-view/Table";
import { _ROUTES } from "../../utils/_routes_constants";

export const TemplateView = () => {
  return (
    <BaseBudgetInput
      title="Template View"
      roles={[_ROLES_BACK._ROLE_ADMIN, _ROLES_BACK._ROLE_CTRL]}
      TableComponent={Table}
      showFiscalDetailsOnFilterSection={false}
      hideTabs={true}
      filters={[
        {
          key: "template",
          route: _ROUTES.INDICATORS_TEMPLATES,
          defaultValue: "",
          label: "Template",
          queryParams: {
            active: 1,
          },
        },
        {
          key: "real_year",
          route: _ROUTES.INDICATOR_TEMPLATE_FILTERS,
          defaultValue: "",
          label: "Real year",
          queryParams: {
            active: 1,
            type: "R",
          },
          layoutProps: {
            selectWidth: "7%",
          },
        },
        {
          key: "forecast_year",
          route: _ROUTES.INDICATOR_TEMPLATE_FILTERS,
          defaultValue: "",
          label: "Forecast year",
          queryParams: {
            active: 1,
            type: "B",
          },
          layoutProps: {
            selectWidth: "7%",
          },
        },
        {
          key: "forecast_version",
          route: _ROUTES.INDICATOR_TEMPLATE_FILTERS,
          defaultValue: "",
          label: "Forecast version",
          dependsOn: "forecast_year",
          queryParams: {
            active: 1,
            type: "B",
          },
          layoutProps: {
            selectWidth: "7%",
          },
        },
        {
          key: "budget_year",
          route: _ROUTES.INDICATOR_TEMPLATE_FILTERS,
          defaultValue: "",
          label: "Budget year",
          queryParams: {
            active: 1,
            type: "B",
          },
          layoutProps: {
            selectWidth: "7%",
          },
        },
        {
          key: "budget_version",
          route: _ROUTES.INDICATOR_TEMPLATE_FILTERS,
          defaultValue: "",
          label: "Budget version",
          dependsOn: "budget_year",
          queryParams: {
            active: 1,
            type: "B",
          },
          layoutProps: {
            selectWidth: "7%",
          },
        },
      ]}
    />
  );
};
